import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';
import Image from '../atoms/Image';

const flip = keyframes`
  0% { opacity: 0; }
  49% { opacity: 0; }
  50% { opacity: 1; }
  100% { opacity: 1; }
`;

const ImageHolder = styled.div`
    &:last-child {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      animation: ${flip} 6s linear infinite;
      @media( ${props => props.theme.breakpoints.md} ) {
        animation: none;
      }
    }
`;

const Holder = styled.div`
  margin-bottom: 2rem;
  @media( ${props => props.theme.breakpoints.md} ) { 
    &:hover {
      ${ImageHolder}:last-child { 
        opacity: 1;
      }
    }
  }
  > a {
    display: block;
    position: relative;
  }
  h3 {
    margin-top: 2rem !important;
  }
  .subhead { 
    text-transform: capitalize;
    margin: 0; 
  }
  > :first-child { margin-top: 0; }
  > :last-child { margin-bottom: 0; }
`;

function ProductCard( { product } ) {
  return (
    <Holder>
      <Link to={`/${product.frontmatter.postType}/${product.frontmatter.id}`}>
        <ImageHolder>
          <Image imgName={product.frontmatter.hero}/>
        </ImageHolder>
        <ImageHolder>
          <Image imgName={product.frontmatter.closeUp}/>
        </ImageHolder>
      </Link>
      <h3>{product.frontmatter.title}{product.frontmatter.price && ` - $${product.frontmatter.price}`}</h3>
      <p className="subhead">
        <em>{product.frontmatter.postType}{product.frontmatter.subHead && ` - ${product.frontmatter.subHead}`}</em>
      </p>
      <p>{product.frontmatter.excerpt}</p>
    </Holder>
  )
}

ProductCard.propTypes = {
  product: PropTypes.object.isRequired,
};

export default ProductCard;
